const routes = {
  root: '/program-builder',
}

export default routes
